// @flow
export default {
  path: '/configuracoes',
  component: () => import('modules/settings/Settings.vue'),
  children: [
    {
      path: '/configuracoes',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            name: 'Settings',
            text: 'Configurações'
          }
        ]
      },
      name: 'Settings',
      component: () => import('modules/settings/Index.vue'),
      beforeEnter: (to, from, next) => {
        next();
      }
    },
    {
      path: '/configuracoes/alterar-senha/',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            name: 'Settings',
            text: 'Configurações'
          },
          {
            text: 'Alterar Senha',
            name: 'AlterPassword'
          }
        ]
      },
      name: 'AlterPassword',
      component: () => import('modules/settings/AlterPassword.vue'),
      beforeEnter: (to, from, next) => {
        next();
      }
    },
    {
      path: '/configuracoes/controle-da-troca-de-senha/',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            name: 'Settings',
            text: 'Configurações'
          },
          {
            text: 'Controle da troca de senha',
            name: 'Control'
          }
        ]
      },
      name: 'Control',
      component: () => import('modules/settings/Control.vue'),
      beforeEnter: (to, from, next) => {
        next();
      }
    },
  ]
};
